import * as types from "./constants";
import update from 'immutability-helper';

const initialState = window.initial_polls_data ? window.initial_polls_data : [];

function pollsReducer(state=initialState, action) {
  switch (action.type) {
    case types.CREATE_POLL:
      return [action.poll];
    case types.SAVE_POLL:
      return [action.poll];
    case types.EDIT_POLL:
      return update(state, {
          [getPollIndex(state, action.poll.id)]: {
            $merge: action.poll,
            editingPoll: {$set: true}
          }
      });
    case types.CANCEL_EDIT_POLL:
      return [action.poll];
    case types.DELETE_POLL:
      return [];
    case types.ADD_RESPONSE:
      return [action.poll];
    case types.SET_VOTED:
      return update(state, {
          [getPollIndex(state, action.pollId)]: {
            voted: {$set: action.voted},
            isHostVoting: {$set: action.isHostVoting}
          }
      });
    default:
      return state;
  }
}

function getPollIndex(state, pollId) {
  return state.map(function(e) {
    return e.id;
  }).indexOf(pollId);
}


export default pollsReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/reducers.es6